import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  loading: false,
  error: null,
  category: [],
  categories: [],
  subCategories: [],
  storeCategory: {},
  updateCategory: {},
  updateSubCategory: {},
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    loadCategoriesRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadCategoriesSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.categories = action.payload?.results;
      state.paginationOption = {
        page: action.payload?.page,
        pageSize: action.payload?.pageSize,
        totalItems: action.payload?.totalItems,
        numberOfPages: action.payload?.numberOfPages,
      };
    },
    loadCategoriesFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    storeCategoryRequested(
      state,
      action: PayloadAction<{
        id: any;
        category_name: any;
        description: string;
      }>
    ) {
      state.loading = true;
      state.error = null;
    },
    storeCategorySuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeCategory = action.payload;
    },
    storeCategoryFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    archiveCategoryRequested(state, action: PayloadAction<{ id: any }>) {
      state.loading = true;
      state.error = null;
    },
    archiveCategorySuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.deleteCategory = action.payload;
    },
    archiveCategoryFail(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },

    storeSubCategoryRequested(
      state,
      action: PayloadAction<{
        categoryId: any;
        name: any;
        description: string;
      }>
    ) {
      state.loading = true;
      state.error = null;
    },
    storeSubCategorySuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.storeSubCategory = action.payload;
    },
    storeSubCategoryFail(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },

    archiveSubCategoryRequested(state, action: PayloadAction<{ id: any }>) {
      state.loading = true;
      state.error = null;
    },
    archiveSubCategorySuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.deleteSubCategory = action.payload;
    },

    archiveSubCategoryFail(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },

    updateCategoryRequested(
      state,
      action: PayloadAction<{
        id: any;
        name: string;
        description: string;
      }>
    ) {
      state.loading = true;
      state.error = null;
    },
    updateCategorySuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.updateCategory = action.payload;
    },
    updateCategoryFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    updateSubCategoryRequested(
      state,
      action: PayloadAction<{
        id: any;
        name: string;
        description: string;
      }>
    ) {
      state.loading = true;
      state.error = null;
    },
    updateSubCategorySuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.updateSubCategory = action.payload;
    },
    updateSubCategoryFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    loadNonPaginatedCategoriesRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadNonPaginatedCategoriesSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.nonPaginatedCategories = action.payload?.result;
    },
    loadNonPaginatedCategoriesFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    loadNonPaginatedSubCategoriesRequested(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    loadNonPaginatedSubCategoriesSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.nonPaginatedSubCategories = action.payload?.result;
    },
    loadNonPaginatedSubCategoriesFail(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },

    loadSubCategoriesByCategoriesRequested(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    loadSubCategoriesByCategoriesSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.filteredSubCategories = action.payload?.result;
    },
    loadSubCategoriesByCategoriesFail(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadCategoriesRequested,
  loadCategoriesSuccess,
  loadCategoriesFail,
  storeCategoryRequested,
  storeCategorySuccess,
  storeCategoryFail,
  storeSubCategoryRequested,
  storeSubCategorySuccess,
  storeSubCategoryFail,
  archiveCategoryFail,
  archiveCategoryRequested,
  archiveCategorySuccess,
  archiveSubCategoryFail,
  archiveSubCategoryRequested,
  archiveSubCategorySuccess,
  updateCategoryRequested,
  updateCategorySuccess,
  updateCategoryFail,
  updateSubCategoryRequested,
  updateSubCategorySuccess,
  updateSubCategoryFail,
  loadNonPaginatedCategoriesFail,
  loadNonPaginatedCategoriesRequested,
  loadNonPaginatedCategoriesSuccess,
  loadNonPaginatedSubCategoriesFail,
  loadNonPaginatedSubCategoriesRequested,
  loadNonPaginatedSubCategoriesSuccess,
  loadSubCategoriesByCategoriesFail,
  loadSubCategoriesByCategoriesRequested,
  loadSubCategoriesByCategoriesSuccess,
} = categoriesSlice.actions;

export default categoriesSlice.reducer;
